module.exports = __webpack_public_path__ + "img/bg_wuyemian.d463e5c6.png";